































import { Vue, Component, Prop } from 'vue-property-decorator'
import StudentRecord from 'components/presenter/item/course/student/GradebookStudentsListItem.vue'
import { Item, Student, StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    StudentRecord
  }
})
export default class ItemCourseGradebookStudents extends Vue {

  @Prop()
  readonly topics!: Map<number, Item>

  @Prop()
  readonly groups!: StudentGroup[]

  @Prop()
  readonly students!: Student[]

  @Prop()
  readonly group!: StudentGroup
}
